import { all } from 'redux-saga/effects'
import appSettingsSagas from './appSettings'
import mapsSagas from './maps'
import userSagas from './user'
import socketSagas from './socket'
import integrationsSagas from './integrations'
import usersSagas from './users'
import consumptionAnalysisSagas from './consumptionAnalysis'
import dictionariesSagas from './dictionaries'
import lifeTimeReportSagas from './lifeTimeReport'
import alarmManagerSagas from './alarmManager'
import analyticsAlarmsSagas from './analyticsAlarms'
import faultAnalyticsSagas from './faultAnalytics'
import passportizationSagas from './passportization'
import tyumenOurHomeSagas from './tyumenOurHome'
import serviceDeskMyCitySagas from './serviceDeskMyCity'
import widgetDashboardSagas from './widgetDashboard'
import installationSagas from './installation'
import reportManagerSagas from './reportManager'
import searchSagas from './search'
import PprSagas from './ppr'
import scheduleManagerSagas from './scheduleManager'
import objectsGroupsSagas from './objectsGroups'
import objectReference from './objectReference'
import actionLog from './actionLog'
import inventorySagas from './inventory'

function* root() {
  yield all([
    appSettingsSagas(),
    socketSagas(),
    mapsSagas(),
    userSagas(),
    integrationsSagas(),
    usersSagas(),
    consumptionAnalysisSagas(),
    dictionariesSagas(),
    lifeTimeReportSagas(),
    alarmManagerSagas(),
    analyticsAlarmsSagas(),
    faultAnalyticsSagas(),
    passportizationSagas(),
    tyumenOurHomeSagas(),
    serviceDeskMyCitySagas(),
    widgetDashboardSagas(),
    installationSagas(),
    reportManagerSagas(),
    searchSagas(),
    PprSagas(),
    scheduleManagerSagas(),
    objectsGroupsSagas(),
    objectReference(),
    actionLog(),
    inventorySagas()
  ])
}

export default root
